/**
 * All Priest abilities except talents go in here. You can also put a talent in here if you want to override something imported in the `./talents` folder, but that should be extremely rare.
 * You need to do this manually, usually an easy way to do this is by opening a WCL report and clicking the icons of spells to open the relevant Wowhead pages, here you can get the icon name by clicking the icon, copy the name of the spell and the ID are in the URL.
 * You can access these entries like other entries in the spells files by importing `common/SPELLS` and using the assigned property on the SPELLS object. Please try to avoid abbreviating properties.
 */
import Spell from 'common/SPELLS/Spell';

const spells = {
  // Shared
  ESSENCE_DEVOURER_HEAL: {
    id: 415673,
    name: 'Essence Devourer',
    icon: 'achievement_raid_terraceofendlessspring04',
  },
  HOLY_NOVA_HEAL: {
    id: 281265,
    name: 'Holy Nova',
    icon: 'spell_holy_holynova',
    manaCost: 1000,
  },
  POWER_WORD_FORTITUDE: {
    id: 21562,
    name: 'Power Word: Fortitude',
    icon: 'spell_holy_wordfortitude',
    manaCost: 2500,
  },
  MIND_SOOTHE: {
    id: 453,
    name: 'Mind Soothe',
    icon: 'spell_holy_mindsooth',
    manaCost: 2500,
  },
  CRYSTALLINE_REFLECTION_TALENT_HEAL: {
    id: 373462,
    name: 'Crystalline Reflection',
    icon: 'ability_priest_reflectiveshield',
  },
  BORROWED_TIME_BUFF: {
    id: 390692,
    name: 'Borrowed Time',
    icon: 'spell_holy_borrowedtime',
  },
  RENEW_HEAL: {
    id: 139,
    name: 'Renew',
    icon: 'spell_holy_renew',
    manaCost: 45000,
  },
  // Discipline Priest:
  GRACE: {
    id: 271534,
    name: 'Mastery: Grace',
    icon: 'spell_holy_hopeandgrace',
  },
  PLEA: {
    id: 200829,
    name: 'Plea',
    icon: 'spell_priest_plea_yellow',
  },
  VOID_SHIELD: {
    id: 1253593,
    name: 'Void Shield',
    icon: 'inv12_apextalent_priest_voidshield',
  },
  MASTER_THE_DARKNESS_BUFF: {
    id: 1253591,
    name: 'Master the Darkness',
    icon: 'inv12_apextalent_priest_voidshield',
  },
  PENANCE_CAST: {
    id: 47540,
    name: 'Penance',
    icon: 'spell_holy_penance',
    manaCost: 4000,
  },
  PENANCE_BOLT_DAMAGE: {
    id: 47666,
    name: 'Penance',
    icon: 'spell_holy_penance',
  },
  PENANCE_BOLT_HEAL: {
    id: 47750,
    name: 'Penance',
    icon: 'spell_holy_penance',
  },
  PENANCE_TWINSIGHT_BOLT_DAMAGE: {
    id: 1232571,
    name: 'Penance (Twinsight)',
    icon: 'spell_holy_penance',
  },
  PENANCE_TWINSIGHT_BOLT_HEAL: {
    id: 1232567,
    name: 'Penance (Twinsight)',
    icon: 'spell_holy_penance',
  },
  HARSH_DISCIPLINE_BUFF: {
    id: 373183,
    name: 'Harsh Discipline',
    icon: 'ability_paladin_handoflight',
  },
  SINS_OF_THE_MANY: {
    id: 280391,
    name: 'Sins of the Many',
    icon: 'spell_holy_holyguidance',
  },
  POWER_WORD_SHIELD: {
    id: 17,
    name: 'Power Word: Shield',
    icon: 'spell_holy_powerwordshield',
    manaCost: 6500,
  },
  SHIELD_OF_ABSOLUTION_BUFF: {
    id: 394624,
    name: 'Shield Of Absolution',
    icon: 'ability_priest_clarityofwill',
  },
  RADIANT_PROVIDENCE_BUFF: {
    id: 410638,
    name: 'Radiant Providence',
    icon: 'spell_priest_power-word',
  },
  SMITE: {
    id: 585,
    name: 'Smite',
    icon: 'spell_holy_holysmite',
    manaCost: 1000,
  },
  ULTIMATE_PENITENCE_DAMAGE: {
    id: 421543,
    name: 'Ultimate Penitence',
    icon: 'ability_priest_ascendance',
  },
  LEVITATE: {
    id: 1706,
    name: 'Levitate',
    icon: 'spell_holy_layonhands',
    manaCost: 2250,
  },
  POWER_WORD_BARRIER_BUFF: {
    id: 81782,
    name: 'Power Word: Barrier',
    icon: 'spell_holy_powerwordbarrier',
  },
  WEAL_AND_WOE_BUFF: {
    id: 390787,
    name: 'Weal and Woe',
    icon: 'spell_priest_burningwill',
  },
  PURIFY: {
    id: 527,
    name: 'Purify',
    icon: 'spell_holy_dispelmagic',
    manaCost: 3250,
  },
  VAMPIRIC_EMBRACE: {
    id: 15286,
    name: 'Vampiric Embrace',
    icon: 'spell_shadow_unsummonbuilding',
  },
  VOIDLING: {
    id: 254232,
    name: 'Voidling',
    icon: 'spell_shadow_shadowfiend',
  },
  LIGHTSPAWN: {
    id: 254224,
    name: 'Shadowfiend',
    icon: 'spell_shadow_shadowfiend',
  },
  LIGHTSPAWN_MELEE: {
    id: -2,
    name: 'Shadowfiend',
    icon: 'spell_shadow_shadowfiend',
  },
  SHADOWFIEND_WITH_GLYPH_OF_THE_SHA: {
    id: 132603,
    name: 'Shadowfiend',
    icon: 'spell_shadow_shadowfiend',
  },
  SHADOW_WORD_PAIN: {
    id: 589,
    name: 'Shadow Word: Pain',
    icon: 'spell_shadow_shadowwordpain',
  },
  PROTECTIVE_LIGHT_BUFF: {
    id: 193065,
    name: 'Protective Light',
    icon: 'spell_holy_holyprotection',
  },
  ATONEMENT_HEAL_NON_CRIT: {
    id: 81751,
    name: 'Atonement',
    icon: 'spell_holy_circleofrenewal',
  },
  ATONEMENT_HEAL_CRIT: {
    id: 94472,
    name: 'Atonement',
    icon: 'spell_holy_circleofrenewal',
  },
  ATONEMENT_BUFF: {
    id: 194384,
    name: 'Atonement',
    icon: 'ability_priest_atonement',
  },
  HALO_HEAL: {
    id: 120692,
    name: 'Halo',
    icon: 'ability_priest_halo',
  },
  HALO_DAMAGE: {
    id: 120696,
    name: 'Halo',
    icon: 'ability_priest_halo',
  },
  SHADOW_DIVINE_STAR_HEAL: {
    id: 390981,
    name: 'Divine Star',
    icon: 'spell_priest_divinestar_shadow2',
  },
  SHADOW_DIVINE_STAR_DAMAGE: {
    id: 390845,
    name: 'Divine Star',
    icon: 'spell_priest_divinestar_shadow2',
  },
  SHADOW_HALO_HEAL: {
    id: 390971,
    name: 'Halo',
    icon: 'ability_priest_halo_shadow',
  },
  SHADOW_HALO_DAMAGE: {
    id: 390964,
    name: 'Halo',
    icon: 'ability_priest_halo_shadow',
  },
  SHADOW_COVENANT_BUFF: {
    id: 322105,
    name: 'Shadow Covenant',
    icon: 'spell_shadow_summonvoidwalker',
  },
  CONTRITION_HEAL: {
    id: 270501,
    name: 'Contrition',
    icon: 'ability_priest_savinggrace',
  },
  CONTRITION_HEAL_CRIT: {
    id: 281469,
    name: 'Contrition',
    icon: 'ability_priest_savinggrace',
  },

  KAM_XIRAFF_BUFF: {
    id: 233997,
    name: "Kam Xi'raff",
    icon: 'ability_priest_savinggrace',
  },
  TWIST_OF_FATE_BUFF: {
    id: 390978,
    name: 'Twist of Fate',
    icon: 'spell_shadow_mindtwisting',
  },
  PRAYER_CIRCLE_BUFF: {
    id: 321379,
    name: 'Prayer Circle',
    icon: 'spell_paladin_divinecircle',
  },

  // Talents:
  // lv90
  EXPIATION_DAMAGE: {
    id: 390844,
    name: 'Expiation',
    icon: 'spell_shadow_shadowpower',
  },
  BURNING_VEHEMENCE_DAMAGE: {
    id: 400370,
    name: 'Burning Vehemence',
    icon: 'ability_paladin_sacredcleansing',
  },

  //Voidweaver
  ENTROPIC_RIFT_DAMAGE: {
    id: 447448,
    name: 'Entropic Rift',
    icon: 'inv_ability_voidweaverpriest_entropicrift',
  },
  COLLAPSING_VOID_DAMAGE: {
    id: 448405,
    name: 'Collapsing Void',
    icon: 'inv_cosmicvoid_groundsate',
  },
  VOID_BLAST_CAST_DISC: {
    id: 450215,
    name: 'Void Blast',
    icon: 'inv_cosmicvoid_missile',
  },
  VOID_FLAY_DAMAGE_DISC: {
    id: 451435,
    name: 'Void Flay',
    icon: 'spell_priest_voidsear',
  },

  // Holy Priest Spells
  BENEDICTION: {
    id: 1262763,
    name: 'Benediction',
    icon: 'inv12_apextalent_priest_benediction',
  },
  DIVINITY_BUFF: {
    id: 1216314,
    name: 'Divinity',
    icon: 'ability_priest_rayofhope',
  },
  FLASH_HEAL: {
    id: 2061,
    name: 'Flash Heal',
    icon: 'spell_holy_flashheal',
    manaCost: 9000,
  },
  PRAYER_OF_MENDING_HEAL: {
    id: 33110,
    name: 'Prayer of Mending',
    icon: 'spell_holy_prayerofmendingtga',
  },
  PRAYER_OF_MENDING_CAST: {
    id: 33076,
    name: 'Prayer of Mending',
    icon: 'spell_holy_prayerofmendingtga',
  },
  PRAYER_OF_MENDING_BUFF: {
    id: 41635,
    name: 'Prayer of Mending',
    icon: 'spell_holy_prayerofmendingtga',
  },
  ECHO_OF_LIGHT_MASTERY: {
    id: 77485,
    name: 'Echo of Light',
    icon: 'spell_holy_aspiration',
  },
  ECHO_OF_LIGHT_HEAL: {
    id: 77489,
    name: 'Echo of Light',
    icon: 'spell_holy_aspiration',
  },
  GUARDIAN_SPIRIT_HEAL: {
    id: 48153,
    name: 'Guardian Spirit',
    icon: 'spell_holy_guardianspirit',
  },
  DIVINE_HYMN_HEAL: {
    id: 64844,
    name: 'Divine Hymn',
    icon: 'spell_holy_divinehymn',
  },
  SERENDIPITY: {
    id: 63733,
    name: 'Holy Words',
    icon: 'spell_holy_serendipity',
  },
  HOLY_FIRE: {
    id: 14914,
    name: 'Holy Fire',
    icon: 'spell_holy_searinglight',
    manaCost: 10000,
  },
  TRAIL_OF_LIGHT_TALENT_HEAL: {
    id: 234946,
    name: 'Trail of Light',
    icon: 'ability_priest_wordsofmeaning',
  },
  COSMIC_RIPPLE_HEAL: {
    id: 243241,
    name: 'Cosmic Ripple Heal',
    icon: 'spell_holy_summonlightwell',
  },
  HOLY_WORD_SERENITY: {
    id: 2050,
    name: 'Holy Word: Serenity',
    icon: 'spell_holy_persuitofjustice',
  },
  HOLY_WORD_SANCTIFY: {
    id: 34861,
    name: 'Holy Word: Sanctify',
    icon: 'spell_holy_divineprovidence',
  },
  PIETY: {
    id: 443126,
    name: 'Premonition of Piety',
    icon: 'inv_ability_oraclepriest_premonitionpiety',
  },

  // Buffs
  SPIRIT_OF_REDEMPTION_BUFF: {
    id: 27827,
    name: 'Spirit of Redemption',
    icon: 'inv_enchant_essenceeternallarge',
  },
  LIGHTWEAVER_TALENT_BUFF: {
    id: 390993,
    name: 'Lightweaver',
    icon: 'spell_holy_greaterheal',
  },
  SURGE_OF_LIGHT_BUFF: {
    id: 114255,
    name: 'Surge of Light',
    icon: 'spell_holy_surgeoflight',
  },
  DIVINE_WORD_CHASTISE_TALENT_BUFF: {
    id: 372761,
    name: 'Divine Favor: Chastise',
    icon: 'priest_icon_chakra_red',
  },
  RESONANT_WORDS_TALENT_BUFF: {
    id: 372313,
    name: 'Resonant Words',
    icon: 'spell_holy_holybolt',
  },
  DIVINE_WORD_SERENITY_TALENT_BUFF: {
    id: 372791,
    name: 'Divine Favor: Serenity',
    icon: 'priest_icon_chakra',
  },
  PERFECTED_FORM_TALENT_BUFF: {
    id: 453983,
    name: 'Perfected Form',
    icon: 'inv_ability_holyfire_buff',
  },
  RESONANT_ENERGY_TALENT_BUFF: {
    id: 453846,
    name: 'Resonant Energy',
    icon: 'ability_priest_halo',
  },
  UNCAT_ARCHON_HALO_RETURN_BUFF: {
    id: 449840,
    name: 'Halo',
    icon: 'ability_priest_halo',
  },
  PREMONITION_OF_SOLACE_DR_AND_SHIELD_BUFF: {
    id: 443526,
    name: 'Premonition of Solace',
    icon: 'inv_ability_oraclepriest_premonitionsolace',
  },
  PREMONITION_OF_SOLACE_CASTER_BUFF: {
    id: 428934,
    name: 'Premonition of Solace',
    icon: 'inv_ability_oraclepriest_premonitionsolace',
  },
  PIETY_BUFF: {
    id: 428930,
    name: 'Premonition of Piety',
    icon: 'inv_ability_oraclepriest_premonitionpiety',
  },
  PREMONITION_OF_INSIGHT_BUFF: {
    id: 428933,
    name: 'Premonition of Insight',
    icon: 'inv_ability_oraclepriest_premonitioninsight',
  },
  EPIPHANY_BUFF: {
    id: 414556,
    name: 'Epiphany',
    icon: 'ability_mage_studentofthemind',
  },
  HOLY_PRIEST_TWW_4PC_DISPLAY: {
    id: 453678,
    name: "4PC Nerub'ar Palace",
    icon: 'trade_engineering',
  },

  // Talents
  BINDING_HEALS_TALENT_HEAL: {
    id: 368276,
    name: 'Binding Heals',
    icon: 'spell_holy_blindingheal',
  },
  EMPOWERED_RENEW_TALENT_HEAL: {
    id: 391359,
    name: 'Empowered Renew',
    icon: 'ability_paladin_infusionoflight',
  },
  LIGHTWELL_TALENT_HEAL: {
    id: 372847,
    name: 'Lightwell',
    icon: 'spell_holy_summonlightwell',
  },
  DIVINE_IMAGE_HEALING_LIGHT_HEAL: {
    id: 196909,
    name: 'Healing Light',
    icon: 'inv_staff_2h_artifactheartofkure_d_04',
  },
  DIVINE_IMAGE_DAZZLING_LIGHT_HEAL: {
    id: 196810,
    name: 'Dazzling Light',
    icon: 'spell_holy_divineprovidence',
  },
  DIVINE_IMAGE_BLESSED_LIGHT_HEAL: {
    id: 196813,
    name: 'Blessed Light',
    icon: 'spell_holy_divineprovidence',
  },
  DIVINE_IMAGE_TRANQUIL_LIGHT_HEAL: {
    id: 196816,
    name: 'Tranquil Light',
    icon: 'spell_holy_divineprovidence',
  },
  HOLY_WORD_CHASTISE_CENSURE_TALENT_INCAPACITATE: {
    id: 200196,
    name: 'Holy Word: Chastise',
    icon: 'spell_holy_chastise',
    manaCost: 5000,
  },
  HOLY_WORD_CHASTISE_CENSURE_TALENT_STUN: {
    id: 200200,
    name: 'Holy Word: Chastise',
    icon: 'spell_holy_chastise',
    manaCost: 15000,
  },
  DIVINE_WORD_SANCTIFY_TALENT_HEAL: {
    id: 372787,
    name: 'Divine Word: Sanctuary',
    icon: 'priest_icon_chakra_blue',
  },
  // Shadow Spells
  MIND_FLAY: {
    id: 15407,
    name: 'Mind Flay',
    icon: 'spell_shadow_siphonmana',
  },
  VAMPIRIC_TOUCH: {
    id: 34914,
    name: 'Vampiric Touch',
    icon: 'spell_holy_stoicism',
  },
  MADDENING_TOUCH_RESOURCE: {
    id: 391232,
    name: 'Maddening Touch',
    icon: 'spell_holy_stoicism',
  },

  MASTERY_SHADOW_WEAVING: {
    id: 343690,
    name: 'Mastery: Shadow Weaving',
    icon: 'spell_shadow_shadetruesight',
  },

  // Void torrent debuff applied on enemy
  VOID_TORRENT_BUFF: {
    id: 289577,
    name: 'Void Torrent',
    icon: 'spell_priest_voidsear',
  },

  VOID_VOLLEY_DAMAGE: {
    id: 1242189,
    name: 'Void Volley',
    icon: 'spell_fire_twilightflamestrike',
  },

  VOID_VOLLEY_CAST: {
    id: 1242173,
    name: 'Void Volley',
    icon: 'spell_fire_twilightflamestrike',
  },

  VOID_BOLT: {
    id: 205448,
    name: 'Void Bolt',
    icon: 'ability_ironmaidens_convulsiveshadows',
  },

  SILENCE: {
    id: 15487,
    name: 'Silence',
    icon: 'ability_priest_silence',
  },

  SHADOWFORM: {
    id: 232698,
    name: 'Shadowform',
    icon: 'spell_shadow_shadowform',
  },
  RESURRECTION: {
    id: 2006,
    name: 'Resurrection',
    icon: 'spell_holy_resurrection',
    manaCost: 2000,
  },

  MIND_VISION: {
    id: 2096,
    name: 'Mind Vision',
    icon: 'spell_holy_mindvision',
  },

  MIND_SEAR: {
    id: 48045,
    name: 'Mind Sear',
    icon: 'spell_shadow_mindshear',
    manaCost: 300,
  },

  SHADOWY_APPARITION: {
    id: 147193,
    name: 'Shadowy Apparition',
    icon: 'ability_priest_shadowyapparition',
  },

  SHADOWY_APPARITION_DAMAGE: {
    id: 413231,
    name: 'Shadowy Apparition',
    icon: 'ability_priest_shadowyapparition',
  },

  SHADOWY_APPARITION_RESOURCE: {
    id: 405746,
    name: 'Shadowy Apparition',
    icon: 'ability_priest_shadowyapparition',
  },

  SHADOWY_APPARITION_CAST: {
    id: 341263,
    name: 'Shadowy Apparition',
    icon: 'ability_priest_shadowyapparition',
  },

  // Shadow Buffs

  VOIDFORM: {
    id: 228264,
    name: 'Voidform',
    icon: 'spell_priest_voidform',
  },

  VOIDFORM_BUFF: {
    id: 194249,
    name: 'Voidform',
    icon: 'spell_priest_voidform',
  },

  SHADOWY_INSIGHT_BUFF: {
    id: 375981,
    name: 'Shadowy Insight',
    icon: 'spell_shadow_possession',
  },

  DEATHSPEAKER_TALENT_BUFF: {
    id: 392511,
    name: 'Deathspeaker',
    icon: 'spell_shadow_demonicfortitude',
  },

  DEATH_AND_MADNESS_TALENT_BUFF: {
    id: 321973,
    name: 'Death and Madness',
    icon: 'spell_shadow_painandsuffering',
  },

  MIND_DEVOURER_TALENT_BUFF: {
    id: 373204,
    name: 'Mind Devourer',
    icon: 'spell_arcane_mindmastery',
  },

  SHATTERED_PSYCHE_TALENT_BUFF: {
    id: 391092,
    name: 'Shattered Psyche',
    icon: 'inv_ability_priest_mindgames',
  },

  // Shadow items:

  TENTACLE_SLAM_TALENT_DAMAGE: {
    id: 1227621,
    name: 'Tentacle Slam',
    icon: 'inv12_ability_priest_tentacleslam',
  },

  INSIDIOUS_IRE_TALENT_BUFF: {
    id: 373213,
    name: 'Insidious Ire',
    icon: 'spell_fire_twilightcano',
  },

  INESCAPABLE_TORMENT_TALENT_DAMAGE: {
    id: 373442,
    name: 'Inescapable Torment',
    icon: 'spell_shadow_chilltouch',
  },

  MIND_FLAY_INSANITY_TALENT_DAMAGE: {
    id: 391403,
    name: 'Mind Flay: Insanity',
    icon: 'spell_fire_twilightflamebreath',
  },

  MIND_FLAY_INSANITY_TALENT_BUFF: {
    id: 391401,
    name: 'Mind Flay: Insanity',
    icon: 'spell_fire_twilightflamebreath',
  },

  IDOL_OF_CTHUN_MIND_FLAY_DAMAGE: {
    id: 193473,
    name: 'Mind Flay',
    icon: 'spell_shadow_siphonmana',
  },

  IDOL_OF_CTHUN_MIND_SEAR_DAMAGE: {
    id: 394979,
    name: 'Mind Sear',
    icon: 'spell_shadow_siphonmana',
  },

  IDOL_OF_CTHUN_RESOURCE: {
    id: 377358,
    name: 'Idol of CThun',
    icon: 'achievement_boss_cthun',
  },

  IDOL_OF_YOGG_SARON_DAMAGE: {
    id: 373279,
    name: 'Void Spike',
    icon: 'spell_priest_mindspike',
  },

  IDOL_OF_NZOTH_DAMAGE_HORRIFIC_VISION: {
    id: 1243105,
    name: 'Horrific Vision',
    icon: 'inv_eyeofnzothpet',
  },

  IDOL_OF_NZOTH_DAMAGE_VISION_OF_NZOTH: {
    id: 1243106,
    name: 'Vision of NZoth',
    icon: 'achievement_nzothraid_nzoth',
  },

  IDOL_OF_YSHAARJ_CALL_OF_THE_VOID: {
    id: 373316,
    name: 'Call of the Void',
    icon: 'achievement_raid_terraceofendlessspring04',
  },

  IDOL_OF_YSHAARJ_OVERBURDENED_MIND: {
    id: 373317,
    name: 'Overburdened Mind',
    icon: 'spell_priest_shadow-mend',
  },

  ANCIENT_MADNESS_TALENT: {
    id: 341240,
    name: 'Ancient Madness',
    icon: 'spell_priest_void-flay',
  },

  PSYCHIC_LINK_TALENT_DAMAGE: {
    id: 199486,
    name: 'Psychic Link',
    icon: 'ability_priest_psychiclink',
  },

  DISPERSION: {
    id: 47585,
    name: 'Dispersion',
    icon: 'spell_shadow_dispersion',
  },

  //Shadow Archon
  SHADOW_PRIEST_ARCHON_RESONANT_ENERGY_DEBUFF: {
    id: 453850,
    name: 'Resonant Energy',
    icon: 'ability_priest_halo',
  },

  SHADOW_PRIEST_ARCHON_SUSTAINED_POTENCY_BUFF: {
    id: 454002,
    name: 'Sustained Potency',
    icon: 'ability_priest_ascension',
  },

  //Shadow Voidweaver
  SHADOW_PRIEST_VOIDWEAVER_VOID_BLAST: {
    id: 450983,
    name: 'Void Blast',
    icon: 'inv_cosmicvoid_missile',
  },
  SHADOW_PRIEST_VOIDWEAVER_ENTROPIC_RIFT_BUFF: {
    id: 450193,
    name: 'Entropic Rift',
    icon: 'inv_ability_voidweaverpriest_entropicrift',
  },
  SHADOW_PRIEST_VOIDWEAVER_VOIDWRAITH_CAST: {
    id: 451235,
    name: 'Voidwraith',
    icon: 'warlock_curse_shadow',
  },

  EVANGELISM_HEAL: {
    id: 472433,
    name: 'Evangelism',
    icon: 'spell_holy_divineillumination',
  },
  POWER_WORD_SHIELD_AS_APPLY: {
    id: 1246768,
    name: 'Power Word: Shield',
    icon: 'spell_holy_powerwordshield',
  },
} satisfies Record<string, Spell>;

export default spells;
